type AmericanFootballRelationIoCBindingsInterface = {}

export const AmericanFootballRelationIoCBindings: AmericanFootballRelationIoCBindingsInterface =
  {}
